import { createActions, createState, createReducer } from 'reduxsauce-crud'
import Immutable from 'seamless-immutable'

const d = { deep: true }

export const EvaluationRedux = createActions({
    getDimentionCatalogueRequest: [''],
    getDimentionCatalogueSuccess: ['data'],
    getDimentionCatalogueError: ['error'],
    getResultsCatalogueRequest: [''],
    getResultsCatalogueSuccess: ['data'],
    getResultsCatalogueError: ['error'],
    getCyclesCatalogueRequest: [''],
    getCyclesCatalogueSuccess: ['data'],
    getCyclesCatalogueError: ['error'],
    getStudyProgramsCatalogueRequest: [''],
    getStudyProgramsCatalogueSuccess: ['data'],
    getStudyProgramsCatalogueError: ['error'],
    getDimentionByStudyProgramRequest: ['params'],
    getDimentionByStudyProgramSuccess: ['data'],
    getDimentionByStudyProgramError: ['error'],
    patchEvaluationRequest: ['payload'],
    patchEvaluationSuccess: ['data'],
    patchEvaluationError: ['error'],
    createEvaluationRequest: ['payload'],
    createEvaluationSuccess: ['data'],
    createEvaluationError: ['error'],
    deleteEvaluationRequest: ['payload'],
    deleteEvaluationSuccess: [],
    deleteEvaluationError: ['error'],
    resetEvaluation: [],
    generatePDFRequest: ['payload'],
    generatePDFSuccess: ['data'],
    generatePDFError: ['error'],
},
{
  prefix: 'EVALUATION_',
  defaultActions: {
    get: true,
  },
},
)

const { Types, Creators } = EvaluationRedux
export const EvaluationTypes = Types
export default Creators

export const INITIAL_STATE = createState({
  dimention: {
    fetching: false,
    error: null,
    results: [],
  },
  evaluation: {
    fetching: false,
    error: null,
    result: {},
  },
  cycles: {
    fetching: false,
    error: null,
    results: [],
  },
  studyPrograms: {
    fetching: false,
    error: null,
    results: [],
  },
  cyclesResults: {
    fetching: false,
    error: null,
    results: [],
  },
}, {
  get: true,
})


const resetEvaluation = state => Immutable.setIn(state.merge({ evaluation: { result: {} } }, d), ['evaluation', 'result'], {})

const getDimentionCatalogueRequest = state => state.merge({ dimention: { fetching: true, error: null } }, d)

const getDimentionCatalogueSuccess = (state, {data})=> state.merge({
  dimention: {
    fetching: false,
    error: null,
    results:data
  },
}, d)
const getDimentionCatalogueError = (state, { error }) =>
  state.merge({ dimention: { fetching: false, error } }, d)

const getResultsCatalogueRequest = state => state.merge({ cyclesResults: { fetching: true, error: null } }, d)

const getResultsCatalogueSuccess = (state, {data})=> state.merge({
  cyclesResults: {
    fetching: false,
    error: null,
    results:data
  },
}, d)
const getResultsCatalogueError = (state, { error }) =>
  state.merge({ cyclesResults: { fetching: false, error } }, d)

const getCyclesCatalogueRequest = state => state.merge({ cycles: { fetching: true, error: null } }, d)

const getCyclesCatalogueSuccess = (state, {data})=> state.merge({
  cycles: {
    fetching: false,
    error: null,
    results:data
  },
}, d)
const getCyclesCatalogueError = (state, { error }) =>
  state.merge({ cycles: { fetching: false, error } }, d)

const getDimentionByStudyProgramRequest = (state) => state.merge({ evaluation: { fetching: true, error: null, result: {} } }, d)

const getDimentionByStudyProgramSuccess = (state, {data})=> state.merge({
  evaluation: {
    fetching: false,
    error: null,
    result:data
  },
}, d)

const getStudyProgramsCatalogueRequest = state => state.merge({ studyPrograms: { fetching: true, error: null } }, d)

const getStudyProgramsCatalogueSuccess = (state, {data})=> state.merge({
  studyPrograms: {
    fetching: false,
    error: null,
    results:data
  },
}, d)
const getStudyProgramsCatalogueError = (state, { error }) =>
  state.merge({ studyPrograms: { fetching: false, error } }, d)

const getDimentionByStudyProgramError = (state, {error}) =>
  Immutable.setIn(
    state.merge({ evaluation: { fetching: false, error } }, d),
    ['evaluation', 'result'],
    {}
  )

const patchEvaluationRequest = (state) => state.merge({ evaluation: { fetching: true, error: null, result: {} } }, d)
const patchEvaluationSuccess = (state, {data})=> state.merge({
    evaluation: {
      fetching: false,
      error: null,
      result:data
    },
  }, d)
const patchEvaluationError = (state, {error}) =>
    state.merge({ evaluation: { fetching: false, error } }, d)

const createEvaluationRequest = (state) => state.merge({ evaluation: { fetching: true, error: null, result: {} } }, d)
const createEvaluationSuccess = (state, {data})=> state.merge({
    evaluation: {
      fetching: false,
      error: null,
      result:data
    },
  }, d)
const createEvaluationError = (state, {error}) =>
    state.merge({ evaluation: { fetching: false, error } }, d)

const deleteEvaluationRequest = (state) => state.merge({ evaluation: { fetching: true, error: null } }, d)
const deleteEvaluationSuccess = state => Immutable.setIn(state.merge({ evaluation: { fetching: false, error: null, result: {} } }, d), ['evaluation', 'result'], {})
const deleteEvaluationError = (state, {error}) =>
    Immutable.setIn(state.merge({ evaluation: { fetching: false, error, result:{} } }, d), ['evaluation', 'result'], {})

const generatePDFRequest = (state) => state.merge({ evaluation: { fetching: true, error: null } }, d)
const generatePDFSuccess = (state, {data}) => state.merge({ evaluation: { fetching: false, error: null, result:data } }, d)
const generatePDFError = (state, {error}) => state.merge({ evaluation: { fetching: false, error } }, d)

export const reducer = createReducer(INITIAL_STATE, {
  [Types.getDimentionByStudyProgramRequest]: getDimentionByStudyProgramRequest,
  [Types.getDimentionByStudyProgramSuccess]: getDimentionByStudyProgramSuccess,
  [Types.getDimentionByStudyProgramError]: getDimentionByStudyProgramError,
  [Types.getDimentionCatalogueRequest]: getDimentionCatalogueRequest,
  [Types.getDimentionCatalogueSuccess]: getDimentionCatalogueSuccess,
  [Types.getDimentionCatalogueError]: getDimentionCatalogueError,
  [Types.getResultsCatalogueRequest]: getResultsCatalogueRequest,
  [Types.getResultsCatalogueSuccess]: getResultsCatalogueSuccess,
  [Types.getResultsCatalogueError]: getResultsCatalogueError,
  [Types.getCyclesCatalogueRequest]: getCyclesCatalogueRequest,
  [Types.getCyclesCatalogueSuccess]: getCyclesCatalogueSuccess,
  [Types.getCyclesCatalogueError]: getCyclesCatalogueError,
  [Types.getStudyProgramsCatalogueRequest]: getStudyProgramsCatalogueRequest,
  [Types.getStudyProgramsCatalogueSuccess]: getStudyProgramsCatalogueSuccess,
  [Types.getStudyProgramsCatalogueError]: getStudyProgramsCatalogueError,
  [Types.patchEvaluationRequest]: patchEvaluationRequest,
  [Types.patchEvaluationSuccess]: patchEvaluationSuccess,
  [Types.patchEvaluationError]: patchEvaluationError,
  [Types.createEvaluationRequest]: createEvaluationRequest,
  [Types.createEvaluationSuccess]: createEvaluationSuccess,
  [Types.createEvaluationError]: createEvaluationError,
  [Types.deleteEvaluationRequest]: deleteEvaluationRequest,
  [Types.deleteEvaluationSuccess]: deleteEvaluationSuccess,
  [Types.deleteEvaluationError]: deleteEvaluationError,
  [Types.resetEvaluation]: resetEvaluation,
  [Types.generatePDFRequest]: generatePDFRequest,
  [Types.generatePDFSuccess]: generatePDFSuccess,
  [Types.generatePDFError]: generatePDFError,
},
{
  defaultActions: {
    get: true,
  },
  Types,
},
)



// WEBPACK FOOTER //
// ./src/Data/Redux/EvaluationRedux.js